export { DialogContent, DialogContentProps } from './DialogContent';
